/* Hint-knop van de cadeaukaart. Hoort bij snippets/cadeaukaart-hint.liquid. */
(function () {
  document.querySelectorAll('[data-vck-hint]').forEach(function (blok) {
    if (blok.dataset.vckKlaar) return; blok.dataset.vckKlaar = '1';
    var knop = blok.querySelector('[data-vck-hint-knop]');
    var keuzes = blok.querySelector('[data-vck-hint-keuzes]');
    function meet(kanaal) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cadeaukaart_hint', hint_kanaal: kanaal }); } catch (e) {}
      // Rechtstreeks naar GA4 (audit 15-09-2026): de dataLayer-push telt alleen als er in GTM een tag voor bestaat.
      try { if (typeof window.gtag === 'function') window.gtag('event', 'cadeaukaart_hint', { hint_kanaal: kanaal }); } catch (e) {}
    }
    knop.addEventListener('click', function () {
      var url = blok.dataset.url;
      if (navigator.share) {
        navigator.share({ title: 'Een cadeautip voor mijn vijver', text: 'Zoek je nog een cadeau voor mij? Een cadeaukaart van Vijvercentrum. Daar zoek ik zelf iets moois voor mijn vijver mee uit.', url: url })
          .then(function () { meet('delen'); })
          .catch(function () { keuzes.classList.add('open'); knop.setAttribute('aria-expanded', 'true'); });
      } else {
        knop.setAttribute('aria-expanded', keuzes.classList.toggle('open') ? 'true' : 'false');
      }
    });
    keuzes.querySelectorAll('[data-vck-hint-kanaal]').forEach(function (a) {
      a.addEventListener('click', function () { meet(a.dataset.vckHintKanaal); });
    });
  });
})();
